<template>
  <section id="login" class="mt-5">
    <div class="container-fluid">
      <div class="row full-height-vh">
        <div class="col-12 d-flex align-items-center justify-content-center gradient-aqua-marine">
          <div class="card px-4 py-2 box-shadow-2 width-600">
            <div class="card-body">
              <div class="card-block">
                <div v-show="showResults">
                  <h3>{{ message }}</h3>
                </div>
                <div v-show="!showResults">
                  <h3>{{ $t("labels.working") }}</h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import AuthService from "../../services/auth"
export default {
    props: {
      currentLocale: {
        type: String,
        default: 'it'
      }
    },
    data(){
        return {
            showResults: false,
            message: ''
        }
    },
    computed: {
        confirmationToken(){
            return this.$route.params.confirmation_token
        }
    },
    mounted: async function() {
        let result = await AuthService.activateAccount(this.confirmationToken)
        this.message = result.data.msg
        this.showResults = true
        this.$router.push({ name: "login" })
    }
}
</script>

